<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo" class="tw-p-0">
<!--            <div class="label-package-expired">-->
<!--              <span>คุณได้ระงับการใช้งานแพ็คเกจ</span>-->
<!--              <a class="ml-2" href="#">เปิดการใช้งานแพ็คเกจ</a>-->
<!--              <v-icon class="ml-2" color="#FFF">mdi-close-circle-outline</v-icon>-->
<!--            </div>-->
            <v-breadcrumbs :items="items" class="tw-pt-10 tw-pl-10">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-row class="row-wrapper tw-px-10">
              <v-col>
                <h2 class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">แพ็คเกจการใช้งาน</h2>
              </v-col>
            </v-row>
            <div class="tw-flex tw-flex-col md:tw-flex-row md:tw-mx-10 tw-mt-3 tw-justify-between tw-mx-4 tw-px-8 tw-py-5 tw-border tw-border-black tw-rounded-4xl">
              <div class="" style="min-width: 160px;">
                <div class="tw-text-base">แพ็คเกจปัจจุบัน</div>
                <div class="tw-text-black tw-font-bold tw-text-2xl tw-p-3 tw-pl-0">{{currentPlan.nameEN || '-'}}</div>
              </div>
              <div class="">
                <div class="tw-text-base">ค่าใช้จ่าย</div>
                <div class="tw-text-black tw-font-bold tw-text-3xl tw-relative tw-p-3 tw-pl-2">
                  <span class="tw-text-sm tw-absolute tw-top-2 tw-left-0">฿</span>
                  <span v-if="onCheckPackageType(currentPlan)">
                    <span>{{(currentPlan.pricePerMonth / 100).toLocaleString()}}</span>
                    <span class="tw-text-sm tw-text-gray"> ต่อเดือน</span>
                  </span>
                  <span v-else>
                    <span>{{(currentPlan.pricePerYear / 100).toLocaleString()}}</span>
                    <span class="tw-text-sm tw-text-gray"> ต่อปี</span>
                  </span>
                </div>
              </div>
              <div class="">
                <div class="tw-text-base">จำนวนเอกสารทั้งหมด</div>
                <div class="tw-flex tw-flex-row tw-justify-between tw-w-64 md:tw-w-80 tw-p-3 tw-pl-0">
                  <div class="tw-font-bold tw-text-2xl tw-text-black">{{showPercentage()}}</div>
                  <div class="tw-font-bold tw-text-base tw-text-gray">{{ companyUsage.countsDocsAll }} / {{currentPlan.docsPerMonth}} ฉบับ</div>
                </div>
                <div class="tw-mt-1 tw-mb-2">
                  <v-progress-linear
                    height="8" background-color="#f2f2f2"
                    color="#6ec39b" :value="calPercentage()">
                  </v-progress-linear>
                </div>
              </div>
              <div class="">
                <div class="tw-text-base">สถานะแพ็คเกจ</div>
                <div class="tw-font-bold tw-text-2xl tw-text-light-green tw-p-3 tw-pl-0">{{onCheckPlanStatus()}}</div>
              </div>
            </div>
            <company-next-plan v-if="companyNextPlan"></company-next-plan>

            <ref-code v-if="companyCreatedAfterSevenDay && userCompany.isAdmin" className="tw-flex tw-flex-col tw-text-center tw-py-8 tw-mt-12 tw-justify-center tw-bg-light-gray "></ref-code>
            <div class="tw-container tw-mx-auto tw-w-11/12 tw-max-w-full tw-mt-6" v-if="userCompany.isAdmin">
              <package-option :on-select-package="onSelectPackage" :current-package="currentPlan" :is-setting="true"></package-option>
            </div>
            <alert-package></alert-package>
            <alert-change-package :update-object-status="updateObjectStatus" :on-close-modal-update-alert="onCloseModalUpdateAlert"></alert-change-package>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import PackageOption from '@/components/company/package'
import RefCode from '@/components/company/ref-code'
import AlertPackage from '../../components/company/alert.package'
import AlertChangePackage from '../../components/company/alert.change.package'
import CompanyNextPlan from '../../components/company/company.next.plan'
import {mapState} from "vuex";
import moment from 'moment';
import 'moment/locale/th'
import updatePackage from "@/libs/updatePackage";
import getCompanyPlanStatus from "@/libs/getCompanyPlanStatus";

moment.locale('th')

export default {
  name: 'Settings',
  components: {
    Admin,
    PackageOption,
    RefCode,
    AlertPackage,
    AlertChangePackage,
    CompanyNextPlan
  },
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
    companyDetail: state => state.companies.companyDetail,
    companyPlan: state => state.companies.companyPlan,
    currentPlan: state => state.paymentPlans.paymentDetail,
    companyNextPlan: state => state.companies.companyNextPlan,
    companyUsage: state => state.companies.companyUsage,
    companyStatus: state => state.statusesByCompany.companyStatus,
    userCompany: state => state.user.userCompany
  }),
  created() {
    this.getData();
  },
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'แพ็คเกจการใช้งาน',
        disabled: true,
      },
    ],
    companyCreatedAfterSevenDay: false,
    selectPackageLoading: false,
    updateObjectStatus: {
      isOpenModal: false,
      status: ""
    },
  }),
  methods: {
    getData: function () {
      let companyID = this.$route.params.companyId
      if (companyID) {
        this.$store.dispatch('user/getRoleUser',{companyId: companyID})
        this.$store.dispatch('companies/getCompanyPlan', {companyID})
        this.$store.dispatch('companies/getCompanyNextPlan', {companyID})
        this.$store.dispatch('companies/getCompany', {companyID})
        this.getUsageDocs()
      }
    },
    checkCompanyCreated: function (){
      if(this.companyDetail['created']) {
        this.companyCreatedAfterSevenDay = moment().endOf('day').diff(moment(new Date(this.companyDetail['created'])), 'day') <= 7
      }
    },
    onCheckPackageType: function (object) {
      return "pricePerMonth" in object
    },
    onSelectPackage: async function (packageID, refCodeObject) {
      if (this.selectPackageLoading) return
      this.selectPackageLoading = true
      let companyID = this.$route.params.companyId
      let packageObject = {paymentPlanID: packageID, partnerID: ""}
      if (refCodeObject) {
        packageObject.partnerID = refCodeObject['id'];
      }

      if (companyID) {
        await updatePackage(packageObject, companyID, false).then((response) => {
          if (response.status === 200) {
            this.updateObjectStatus = {isOpenModal: true, status: "success"}
          } else {
            this.updateObjectStatus = {isOpenModal: true, status: "error"}
          }
          this.selectPackageLoading = false
        })
      }
    },
    onCloseModalUpdateAlert: function () {
      this.updateObjectStatus = {isOpenModal: false, status: ""}
      let companyID = this.$route.params.companyId
      if (companyID) {
        this.$store.dispatch('companies/getCompanyNextPlan', {companyID})
      }
    },
    getUsageDocs: function () {
      let companyID = this.$route.params.companyId
      let date = new Date()
      this.$store.dispatch('companies/getCompanyUsage', {companyID, date: date.getFullYear() + '-' + date.getMonth()})
    },
    onCheckPlanStatus: function () {
      return getCompanyPlanStatus(this.companyStatus)
    },
    calPercentage: function () {
      return (this.companyUsage && this.companyUsage['countsDocsAll'] && this.currentPlan['docsPerMonth']) ? ((this.companyUsage.countsDocsAll / this.currentPlan.docsPerMonth) * 100).toFixed(2): 0
    },
    showPercentage: function () {
      let percentage = this.calPercentage()
      if(percentage) return `${percentage}%`
      else return ""
    }
  },
  watch: {
    companyDetail: {
      handler: function (companyDetail) {
        if(companyDetail){
          this.checkCompanyCreated();
        }
      }
    },
  },
}
</script>

<style lang="scss">
.row-wrapper {
  padding-left: 20px;
}

.border-radius {
  border: 1px solid #707070;
  border-radius: 20px;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;

  //width: 990px;
  height: 132px;
  border-radius: 20px;
  border: solid 1px #707070;

  margin: 15px;
  justify-content: space-between;
  list-style: none;
}

.flex-item {
  padding: 15px;

  %equal-text {
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
  }

  .bold-green {
    @extend %equal-text;
    color: #6ec39b;
  }

  .bold-grey {
    @extend %equal-text;
    color: #c4c4c4;
  }

  .bold-red {
    @extend %equal-text;
    color: #c9242b;
  }

  .price {
    @extend %equal-text;
    color: #191919;
  }

  .price-grey {
    @extend %equal-text;
    color: #c4c4c4;
  }
}

.flex-document {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: baseline;
  width: 300px;

  .text-grey {
    color: #c4c4c4;
  }
}

.package-adjust {
  color: #707070 !important;
}

.package-open {
  color: #6ec39b !important;
}

.flex-container-choose-package {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin: 15px;
}

.flex-item-choose-package {
  position: relative;
  padding: 15px;
  margin: 3px;
  width: 240px;
  height: 246px;
  border-radius: 20px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  %equal-color {
    color: #191919;
  }

  .basic {
    font-size: 20px;
    font-weight: bold;
    @extend %equal-color;
  }

  .doc-count {
    margin-top: 10px;
    font-size: 12px;
    @extend %equal-color;
  }

  .price {
    margin-top: 35px;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    @extend %equal-color;
  }

  .price-credit-text {
    margin-top: 25px;
    font-size: 12px;
    color: #191919;
  }

  .change-package {
    display: flex;
    flex-flow: row;
    justify-content: center;

    cursor: pointer;
    margin-top: 30px;
    font-size: 16px;
    color: #6ec39b;
  }

  .align-flex-end {
    align-self: flex-end;
  }

  .black-label {
    position: absolute;
    left: 0;
    top: 12px;
    width: 8px;
    height: 24px;
    background-color: #191919;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.label-package-expired {
  position: absolute;
  right: 0;
  top: 0;
  width: 412px;
  height: 66px;
  padding-top: 20px;
  color: #FFFFFF;
  background-color: #c9242b;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 20px;

  font-size: 16px;
  text-align: center;

  a {
    color: #FFFFFF;
  }
}

.v-card__text {
  position: relative;
}
</style>
